import './index.scss'
import text from './text.json'
import Input from '../../core/input'
import CustomSelect from '../../core/customSelect'
import authMethods from '../../../data/authMethods.json'
import {useSelector} from 'react-redux'
import classNames from 'classnames'

const names = {
    is_advanced: 'is_advanced',
    auth_method: 'auth_method',
    bearer_token: 'bearer_token',
    username: 'username',
    password: 'password'
}

const AuthMethods = ({values, handleChange, setFieldValue, errors, handleInfo, active}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    return (
        <>
            <div className={classNames('json-box', {
                dark: isDarkMode
            })}>
                <div className="json-box-header">
                    <span className="title">{text.auth_method}</span>
                </div>
                <div className="json-box-content auth-headers">
                    <CustomSelect
                        options={Object.values(authMethods)}
                        value={values[names.auth_method]}
                        onChange={setFieldValue}
                        placeholder={text.type}
                        activeInfo={active === names.auth_method}
                        handleInfo={(state) => handleInfo(names.auth_method, state)}
                        infoText={text.auth_method_info}
                        isDisabled={!values[names.is_advanced]}
                        isClearable={true}
                        name={names.auth_method} />

                    {values[names.auth_method]?.value === authMethods.bearer_token.value && (
                        <Input
                            type="text"
                            value={values.bearer_token}
                            placeholder={text.token}
                            name={names.bearer_token}
                            error={errors.bearer_token}
                            inputIsDisabled={!values[names.is_advanced]}
                            onChange={handleChange}
                        />
                    )}
                    {values[names.auth_method]?.value === authMethods.basic_auth.value && (
                        <>
                            <Input
                                type="text"
                                value={values.username}
                                placeholder={text.username}
                                name={names.username}
                                error={errors.username}
                                onChange={handleChange}
                            />
                            <Input
                                type="password"
                                value={values.password}
                                placeholder={text.password}
                                name={names.password}
                                error={errors.password}
                                onChange={handleChange}
                            />
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

export default AuthMethods
